var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIconHomepage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1134 1063.2-212.4-212.4c79.199-88.801 128.4-206.4 128.4-334.8 0-277.2-225.6-502.8-502.8-502.8s-502.8 225.6-502.8 502.8 225.6 502.8 502.8 502.8c98.398 0 189.6-28.801 266.4-76.801l220.8 220.8c13.199 13.199 31.199 20.398 49.199 20.398s36-7.1992 49.199-20.398c28.805-27.602 28.805-72 1.2031-99.602zm-949.2-547.2c0-199.2 162-362.4 362.4-362.4 200.4 0 361.2 163.2 361.2 362.4s-162 362.4-361.2 362.4-362.4-162-362.4-362.4z",
    fill: "#2c3530"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconHomepage);
export default __webpack_public_path__ + "static/media/search-icon-homepage.6b009bbfa456cb59ca2118c4a3e576cc.svg";
export { ForwardRef as ReactComponent };